import React from 'react';
import { Star } from 'lucide-react';
import { mockData } from '../data/mock';

const Testimonials = () => {
  return (
    <section id="testimonials" style={styles.section}>
      <div className="container">
        {/* Trainee Bewertungen */}
        <div style={styles.subsection}>
          <h2 className="heading-1" style={styles.title}>Was unsere Trainees sagen</h2>
          <p className="body-large" style={styles.subtitle}>
            Echte Bewertungen von Google
          </p>
          
          <div style={styles.grid}>
            {mockData.testimonials.trainee.map((testimonial) => (
              <div key={testimonial.id} className="wahr-card" style={styles.card}>
                <div style={styles.stars}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={20} fill="var(--brand-primary)" color="var(--brand-primary)" />
                  ))}
                </div>
                <p className="body-medium" style={styles.text}>
                  "{testimonial.text}"
                </p>
                <div style={styles.author}>
                  <div style={styles.authorName} className="heading-3">{testimonial.name}</div>
                  <div style={styles.authorRole} className="body-medium">{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Kunden Bewertungen */}
        <div style={styles.subsection}>
          <h2 className="heading-1" style={styles.title}>Kundenstimmen</h2>
          <p className="body-large" style={styles.subtitle}>
            Was unsere Partner über uns sagen
          </p>
          
          <div style={styles.clientGrid}>
            {mockData.testimonials.clients.map((testimonial) => (
              <div key={testimonial.id} className="wahr-card" style={styles.clientCard}>
                <div style={styles.stars}>
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={24} fill="var(--brand-primary)" color="var(--brand-primary)" />
                  ))}
                </div>
                <p className="body-large" style={styles.clientText}>
                  "{testimonial.text}"
                </p>
                <div style={styles.clientAuthor}>
                  <div style={styles.clientName} className="heading-2">{testimonial.name}</div>
                  <div style={styles.clientRole} className="body-large">{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    background: 'var(--bg-page)',
  },
  subsection: {
    marginBottom: '80px',
  },
  title: {
    textAlign: 'center',
    marginBottom: '16px',
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: '56px',
    color: 'var(--text-secondary)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '32px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  stars: {
    display: 'flex',
    gap: '4px',
  },
  text: {
    fontStyle: 'italic',
    color: 'var(--text-secondary)',
    flexGrow: 1,
  },
  author: {
    borderTop: '1px solid var(--border-light)',
    paddingTop: '16px',
  },
  authorName: {
    marginBottom: '4px',
    fontSize: '1.125rem',
  },
  authorRole: {
    color: 'var(--text-light)',
    fontSize: '0.875rem',
  },
  clientGrid: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  clientCard: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '40px',
  },
  clientText: {
    fontStyle: 'italic',
    color: 'var(--text-secondary)',
    lineHeight: '1.8',
  },
  clientAuthor: {
    borderTop: '2px solid var(--brand-primary)',
    paddingTop: '20px',
    textAlign: 'center',
  },
  clientName: {
    marginBottom: '8px',
    fontSize: '1.5rem',
  },
  clientRole: {
    color: 'var(--brand-primary)',
    fontWeight: '500',
  },
};

export default Testimonials;
